import Vue from 'vue'

import Default from './Default.vue'
import NoMenu from './NoMenu.vue'

Vue.component('default-layout', Default)
Vue.component('no-menu-layout', NoMenu)
